import PopSlideUp from '@/mobile/components/ui/PopSlideUp'
import PopMtmChat from '@/mobile/components/ui/PopMtmChat'
import UserInfo from '@/mobile/components/users/UserInfo'
export  const chatmtm = {
    props:{
        mtm_join:{default:''}
    },
    data(){
        return{
            mtm_chat:false,
            mtm_room_id:'', 
        }
    },
    components:{
        UserInfo,PopSlideUp,PopMtmChat    
    },
    computed:{
        getMtmRoomId(){
            if(this.mtm_room_id !=='')
            {
                return this.mtm_room_id
            }
            else if(this.mtm_join !=='')
            {
                return this.mtm_join
            }
        }    
    },
    methods:{
        close_mtm_chat(){
            this.mtm_chat =false;  
            this.$emit('mtm-close')
        },
        mtmChatJoin(data){   
            //alert(data);   
            this.mtm_room_id = data;      
            this.mtm_chat =true;            
        },
        viewUserInfo(data){
            this.userInfo = data;
            // console.log(this.userInfo);
            // alert('유저인포 호출');
        },
        closeUserInfo(){
            this.userInfo = {show:false}; 
            //this.mtm_chat =true;
        },        
    }
}